import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { getHttpErrorMessage } from '../errors/error-utils';
import { LoggerService } from '../logger';

@Injectable()
export class ErrorInterceptorService implements HttpInterceptor {
  constructor(private logger: LoggerService) {}

  intercept(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    request: HttpRequest<any>,
    next: HttpHandler,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ): Observable<HttpEvent<any>> {
    return next
      .handle(request)
      .pipe(catchError((error: HttpErrorResponse) => this.handleError(error)));
  }

  private handleError(error: HttpErrorResponse) {
    this.logError(error);
    return throwError(error);
  }

  private logError(error: HttpErrorResponse) {
    if (error.status >= 500) {
      this.logger.error(error);
    } else if (error.status !== 404) {
      this.logger.log(getHttpErrorMessage(error));
    }
  }
}
